import {connect} from 'react-redux'
import * as customerSelector from '../../../customer/state/detail/selector'
import * as selector from '../../../customer/state/file-upload/selector'
import {FILE_TYPE_CUSTOMS_INVOICE} from "../../../customer/state/const";
import {CUSTOMS_INVOICE_LIST_WIDGET} from "../../../process/ui-definition/process-ui";
import CustomerFileUpload from "../../../customer/component/scan-file-upload/CustomerFileUpload";
import * as action from "../../../customer/state/file-upload/action";
import * as customerAction from "../../../customer/state/detail/action";


const mapStateToProps = state => {
    return {
        ...selector.selectOwnState(state),
        customer: customerSelector.selectCustomer(state),
        readOnly: true,
        fetching: selector.selectIsFetching(state, FILE_TYPE_CUSTOMS_INVOICE),
        widgetId: CUSTOMS_INVOICE_LIST_WIDGET,
        fileType: FILE_TYPE_CUSTOMS_INVOICE
    }
}

const mapDispatchToProps = {
    setDeleteFlag: action.setDeleteFlag,
    onUploadSuccess: customerAction.addCustomerFile,
    onFileDeleteFlagSuccess: customerAction.onFileDeleteFlagSuccess,
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerFileUpload)


// WEBPACK FOOTER //
// ./src/modules/sales-order/component/task-widget/CustomsInvoiceListWidgetContainer.js